import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Building2, TrendingUp, ShieldCheck, ChevronRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const ecosystemItems = [{
  title: "Real Estate Capital",
  icon: Building2,
  services: ["Rental Portfolio Financing", "Bridge & Transitional Capital", "Construction & Development"],
  link: "/RealEstateCapitalPage"
}, {
  title: "Business Funding",
  icon: TrendingUp,
  services: ["Working Capital Solutions", "Structured Term Loans", "Growth & Expansion Capital"],
  link: "/BusinessCapitalPage"
}, {
  title: "Private Credit & Protection",
  icon: ShieldCheck,
  services: ["Institutional Capital Access", "Private Credit Networks", "Credit & Financing Protection"],
  link: "/CreditProtectionPage"
}];
export default function CapitalEcosystem() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="capital-ecosystem" ref={ref} className={cn("dark bg-background text-foreground py-24 px-6 md:px-12 lg:px-24", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10", "transition-all duration-1000 ease-out")}>
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {ecosystemItems.map((item, i) => <Card key={i} data-index={i} className="group relative bg-card border border-border hover:border-white/40 transition-all duration-500 rounded-sm p-0 overflow-hidden shadow-none hover:shadow-2xl hover:shadow-white/5">
              {}
              <div className="absolute inset-0 bg-gradient-to-b from-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
              
              <CardHeader className="p-12 pb-6 space-y-8">
                <item.icon strokeWidth={1} className="w-12 h-12 text-foreground/90 group-hover:text-white transition-colors duration-300" />
                <CardTitle className="font-serif text-3xl font-light tracking-wide text-foreground">
                  {item.title}
                </CardTitle>
              </CardHeader>
              
              <CardContent className="p-12 pt-0 pb-10">
                <ul className="space-y-4">
                  {item.services.map((service, j) => <li key={j} data-index={j} className="flex items-start text-muted-foreground text-sm tracking-wide group-hover:text-foreground/80 transition-colors duration-300">
                      <span className="mr-3 mt-2 w-1 h-1 bg-foreground/40 rounded-full shrink-0" />
                      {service}
                    </li>)}
                </ul>
              </CardContent>

              <CardFooter className="p-12 pt-0">
                <Link to={item.link} className="group/link flex items-center text-xs uppercase tracking-widest text-foreground/60 hover:text-foreground transition-colors font-medium">
                  Deep Dive
                  <ChevronRight className="ml-2 w-4 h-4 transition-transform duration-300 group-hover/link:translate-x-1" />
                </Link>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}